module.exports = __webpack_public_path__ + "static/screenshot5-61e5c764fd9453cd1bc1abd1195ad35a.png";